export default "__VITE_PUBLIC_ASSET__2c54dce8__"